interface ConciergeQuickActionsProps {
  actions: string[]
  onSelect: (action: string) => void
}

export function ConciergeQuickActions({ actions, onSelect }: ConciergeQuickActionsProps) {
  return (
    <div className="flex flex-wrap gap-1.5 mt-2">
      {actions.map((action) => (
        <button
          key={action}
          type="button"
          onClick={() => onSelect(action)}
          className="px-3 py-1.5 text-xs border border-border rounded-full bg-card text-muted-foreground cursor-pointer transition-colors duration-150 hover:border-primary hover:text-primary hover:bg-teal-50 font-sans"
        >
          {action}
        </button>
      ))}
    </div>
  )
}
